"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var color_1 = __importDefault(require("@dicebear/avatars/lib/color"));

var eyes_1 = __importDefault(require("./eyes"));

var face_1 = __importDefault(require("./face"));

var mouth_1 = __importDefault(require("./mouth"));

var sides_1 = __importDefault(require("./sides"));

var texture_1 = __importDefault(require("./texture"));

var top_1 = __importDefault(require("./top"));

var group = function group(random, content, chance, x, y) {
  if (random.bool(chance)) {
    return "<g transform=\"translate(".concat(x, ", ").concat(y, ")\">").concat(content, "</g>");
  }

  return '';
};

function default_1(random) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options = Object.assign({
    primaryColorLevel: 600,
    secondaryColorLevel: 400,
    mouthChance: 100,
    sidesChance: 100,
    textureChance: 50,
    topChance: 100
  }, options);
  var colorsCollection = [];
  Object.keys(color_1.default.collection).forEach(function (color) {
    if (options.colors === undefined || options.colors.length === 0 || options.colors.indexOf(color) !== -1) {
      colorsCollection.push(color_1.default.collection[color]);
    }
  });
  var primaryColorCollection = random.pickone(colorsCollection);
  var secondaryColorCollection = random.pickone(colorsCollection);
  var primaryColor = new color_1.default(primaryColorCollection[options.primaryColorLevel]);
  var secondaryColor = new color_1.default(primaryColorCollection[options.secondaryColorLevel]);

  if (options.colorful) {
    secondaryColor = new color_1.default(secondaryColorCollection[options.secondaryColorLevel]);
  }

  var eyes = random.pickone(eyes_1.default);
  var face = random.pickone(face_1.default);
  var mouth = random.pickone(mouth_1.default);
  var sides = random.pickone(sides_1.default);
  var texture = random.pickone(texture_1.default);
  var top = random.pickone(top_1.default); // prettier-ignore

  return ['<svg viewBox="0 0 180 180" xmlns="http://www.w3.org/2000/svg" fill="none">', group(random, sides(secondaryColor), options.sidesChance, 0, 66), group(random, top(secondaryColor), options.topChance, 41, 0), group(random, face(primaryColor, random.bool(options.textureChance) ? texture() : undefined), 100, 25, 44), group(random, mouth(), options.mouthChance, 52, 124), group(random, eyes(), 100, 38, 76), '</svg>'].join('');
}

exports.default = default_1;